var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDiamond = function SvgDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Diamond_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "m19.997 33.72-9.07-12.978h36.275L39.201 33.72H19.997"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M10.916 20.788h36.67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "M1.692 34.114 29.293 68.88l27.601-34.766"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M1.583 34.484 29.296 68.88l27.132-34.266"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "m19.981 34.114 9.312 34.766 9.313-34.766"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M1.692 34.645 10.89 20.79l9.427 13.855H1.692Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "m19.981 34.644 9.27-13.7 9.355 13.7H19.98"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "m38.275 34.644 9.223-13.842 9.048 13.842h-18.27"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "m21.032 12.485-5.45-5.427M37.1 12.485l5.45-5.427M29.065 12.485V2.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Diamond_svg__b)",
    d: "M21.034 13.795a1.315 1.315 0 0 1-.93-.384l-5.452-5.427a1.306 1.306 0 0 1 .02-1.833 1.318 1.318 0 0 1 1.84-.019l5.452 5.427a1.307 1.307 0 0 1-.93 2.24v-.004"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Diamond_svg__c)",
    d: "M37.1 13.795a1.32 1.32 0 0 1-1.22-.81 1.304 1.304 0 0 1 .29-1.43l5.45-5.428a1.315 1.315 0 0 1 1.447-.305 1.316 1.316 0 0 1 .818 1.226 1.304 1.304 0 0 1-.404.931l-5.452 5.432a1.311 1.311 0 0 1-.93.383"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Diamond_svg__d)",
    d: "M29.064 13.795c-.35 0-.684-.138-.93-.384a1.306 1.306 0 0 1-.386-.926V2.987c0-.348.139-.68.385-.926a1.318 1.318 0 0 1 2.246.926v9.498c0 .347-.138.68-.385.926a1.318 1.318 0 0 1-.93.383"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Diamond_svg__b",
    x1: 18.32,
    x2: 18.32,
    y1: 5.767,
    y2: 13.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Diamond_svg__c",
    x1: 39.833,
    x2: 39.833,
    y1: 5.724,
    y2: 13.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Diamond_svg__d",
    x1: 29.064,
    x2: 29.064,
    y1: 1.677,
    y2: 13.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB100"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Diamond_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h58v70H0z"
  })))));
};
export default SvgDiamond;